import _ from 'lodash';
import transferService from '@/services/transferService';
import Transfer from '../../model/transfer';

const state = {
  baseUrl: '/transfer',
  transfers: [],
  pagination: {},
  transfer: null,
  loading: false
};

const actions = {
  list({ dispatch, commit }, { type = 'transfer', query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setTransfers', { transfers: [], pagination: {} });

    transferService
      .list({ type, query })
      .then(response => {
        commit('setTransfers', { transfers: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { type = 'transfer', transferId, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setTransfer', { transfer: {} });

    transferService
      .getOne({ type, transferId })
      .then(response => {
        commit('setTransfer', { transfer: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { type = 'transfer', transfer, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    transferService
      .postOne({ type, transfer })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'transfer' ? 'New transfer has been added.' : 'New transfer has been added.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { type = 'transfer', transferId, transfer, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    transferService
      .patchOne({ type, transferId, newTransfer: transfer })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'transfer' ? 'Transfer has been updated.' : 'Transfer has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { type = 'transfer', transferId, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    transferService
      .deleteOne({ type, transferId })
      .then(_response => {
        dispatch('list', { type });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'transfer' ? 'Transfer has been deleted.' : 'Transfer has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setTransfers(state, { transfers, pagination }) {
    let rowNum = pagination.first_row_no;
    state.transfers = _.map(transfers, transfer => {
      const newTransfer = new Transfer({
        rowNum,
        id: transfer.id,
        userId: transfer.user_id,
        record: transfer.record,
        recNum: transfer.rec_num,
        recFrm: transfer.rec_frm,
        recTo: transfer.rec_to,
        amount: transfer.amount,
        balance: transfer.balance,
        createdAt: transfer.created_at
      });

      rowNum -= 1;
      return newTransfer;
    });
    state.pagination = pagination;

    state.loading = false;
  },
  setTransfer(state, { transfer }) {
    state.transfer = new Transfer({
      id: transfer.id,
      userId: transfer.user_id,
      record: transfer.record,
      recNum: transfer.rec_num,
      recFrm: transfer.rec_frm,
      recTo: transfer.rec_to,
      amount: transfer.amount,
      balance: transfer.balance,
      createdAt: transfer.created_at
    });

    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
